module.exports = __webpack_public_path__ + "static/icon_industrial_orange-0ece4ff16ee923e6d1031ae95b17cae4.png";